"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
/**
 * Extended Field
 */
var ExtendedField = /** @class */ (function (_super) {
    __extends(ExtendedField, _super);
    function ExtendedField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onExtendedChange = function (evt) {
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange(evt.target.value);
            }
        };
        return _this;
    }
    ExtendedField.prototype.render = function () {
        var extended = this.props.extended;
        return (React.createElement(antd_1.Radio.Group, { defaultValue: extended === true ? extended : false, buttonStyle: "solid", onChange: this.onExtendedChange, size: "small" },
            React.createElement(antd_1.Radio.Button, { value: false }, "16-bit"),
            React.createElement(antd_1.Radio.Button, { value: true }, "32-bit")));
    };
    return ExtendedField;
}(React.PureComponent));
exports.ExtendedField = ExtendedField;
exports.default = ExtendedField;
//# sourceMappingURL=ExtendedField.js.map